import { PerformanceTimeline } from './PerformanceTimeline';
import { PerformanceTimelineStub } from './PerformanceTimelineStub';
import { IPerformanceTimeline } from './IPerformanceTimeline';

const isPerformanceSupported = (): boolean => {
  try {
    return !!window.performance &&
      !!window.performance.mark &&
      !!window.performance.measure &&
      !!window.performance.getEntries &&
      !!window.performance.getEntriesByName &&
      !!window.performance.getEntriesByType;
  }
  catch {
    return false;
  }
}

export const performanceTimeline: IPerformanceTimeline = isPerformanceSupported() ? new PerformanceTimeline() : new PerformanceTimelineStub();


// WEBPACK FOOTER //
// ./packages/platform-utils/services/performanceTimeline/index.ts